import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PAGE_ROUTE_PATH } from '@/constants';

/**
 * 利用規約更新 カスタムフック
 */
export const useNeedAgreement = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  /**
   * 利用規約が更新された時に利用規約画面に遷移する
   */
  const needAgreement = useCallback(() => {
    const fullPath = pathname + search;
    navigate(PAGE_ROUTE_PATH.AGREEMENT, {
      state: fullPath,
    });
  }, [navigate, pathname, search]);

  return {
    needAgreement,
  };
};
